module.exports = __webpack_public_path__ + "img/1fa17ac.jpg";